import { createFileRoute } from '@tanstack/react-router'
import { RequireSuperadmin } from '@/shared/components'
import { EmployeesPage } from '@/pages/employees/EmployeesPage'

export const Route = createFileRoute('/employees')({
  component: () => (
    <RequireSuperadmin>
      <EmployeesPage />
    </RequireSuperadmin>
  ),
})
